module.exports = __webpack_public_path__ + "img/开关T1.2f8f1512.png";